import { Bet } from "src/types";
import { RACERS } from "src/constants";

export const sort = (bets: Array<Bet>) => {
  const result: Array<Array<Bet>> = [];

  RACERS.forEach((first) => {
    const temp: Array<Bet> = [];
    RACERS.forEach((second) => {
      const bet = bets.find(
        (bet) =>
          bet.type === "competition" &&
          bet.racers[0] === first &&
          bet.racers[1] === second
      );
      if (bet) {
        temp.push(bet);
      }
    });
    result.push(temp);
  });

  return result;
};
